import { Routes } from '@angular/router';
import { SellerSignupComponent } from './seller-signup';

export const sellerSignupRoutes: Routes = [
  {
    path: '',
    title: 'Seller Sign Up',
    component: SellerSignupComponent,
    children: [
      {
        path: '',
        redirectTo: 'personal-info',
        pathMatch: 'full',
      },
      {
        path: 'personal-info',
        title: 'Seller Sign Up (Personal Info)',
        loadComponent: () =>
          import('./steps/personal-info-step/personal-info-step').then(
            (x) => x.PersonalInfoStep,
          ),
      },
      {
        path: 'company-info',
        title: 'Seller Sign Up (Company Info)',
        loadComponent: () =>
          import('./steps/company-info-step/company-info-step').then(
            (x) => x.CompanyInfoStep,
          ),
      },
      {
        path: 'store-profile',
        title: 'Seller Sign Up (Store Profile)',
        loadComponent: () =>
          import('./steps/store-profile-step/store-profile-step').then(
            (x) => x.StoreProfileStep,
          ),
      },
      {
        path: 'feedback',
        title: 'Seller Sign Up (Feedback)',
        loadComponent: () =>
          import('./steps/feedback-step/feedback-step').then((x) => x.FeedbackStep),
      },
    ],
  },
];
